import documentContainWacElements from './documentContainWacElements';
import isExcelDesktopDocument from './isExcelDesktopDocument';
import isExcelOnlineDocument from './isExcelOnlineDocument';
import isGoogleSheetDocument from './isGoogleSheetDocument';
import isPowerPointDesktopDocument from './isPowerPointDesktopDocument';
import isWordDesktopDocument from './isWordDesktopDocument';
import shouldConvertToSingleImage from './shouldConvertToSingleImage';
var getSourceFunctions = new Map([
    [0 /* WordDesktop */, isWordDesktopDocument],
    [1 /* ExcelDesktop */, isExcelDesktopDocument],
    [2 /* ExcelOnline */, isExcelOnlineDocument],
    [3 /* PowerPointDesktop */, isPowerPointDesktopDocument],
    [5 /* WacComponents */, documentContainWacElements],
    [4 /* GoogleSheets */, isGoogleSheetDocument],
    [7 /* SingleImage */, shouldConvertToSingleImage],
]);
/**
 * This function tries to get the source of the Pasted content
 * @param event the before paste event
 * @param shouldConvertSingleImage Whether convert single image is enabled.
 * @returns The Type of pasted content, if no type found will return {KnownSourceType.Default}
 */
export default function getPasteSource(event, shouldConvertSingleImage) {
    var htmlAttributes = event.htmlAttributes, clipboardData = event.clipboardData, fragment = event.fragment;
    var result = null;
    var param = {
        htmlAttributes: htmlAttributes,
        fragment: fragment,
        shouldConvertSingleImage: shouldConvertSingleImage,
        clipboardData: clipboardData,
    };
    getSourceFunctions.forEach(function (func, key) {
        if (!result && func(param)) {
            result = key;
        }
    });
    return result !== null && result !== void 0 ? result : 6 /* Default */;
}
//# sourceMappingURL=getPasteSource.js.map